import { IIconProps } from './add';

export const IcoDragAndDrop: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    data-cy={`IcoDragAndDrop${cy}`}
  >
    <path
      d="M3.5625 6.305V3.5C3.5625 2.465 4.4025 1.625 5.4375 1.625C6.4725 1.625 7.3125 2.465 7.3125 3.5V6.305C8.22 5.6975 8.8125 4.67 8.8125 3.5C8.8125 1.6325 7.305 0.125 5.4375 0.125C3.57 0.125 2.0625 1.6325 2.0625 3.5C2.0625 4.67 2.655 5.6975 3.5625 6.305ZM10.9425 9.7775L7.5375 8.0825C7.41 8.03 7.275 8 7.1325 8H6.5625V3.5C6.5625 2.8775 6.06 2.375 5.4375 2.375C4.815 2.375 4.3125 2.8775 4.3125 3.5V11.555C1.6125 10.985 1.6575 10.9925 1.56 10.9925C1.3275 10.9925 1.1175 11.09 0.9675 11.24L0.375 11.84L4.08 15.545C4.2825 15.7475 4.5675 15.875 4.875 15.875H9.9675C10.53 15.875 10.965 15.4625 11.0475 14.915L11.61 10.9625C11.6175 10.91 11.625 10.8575 11.625 10.8125C11.625 10.3475 11.34 9.9425 10.9425 9.7775Z"
      fill="currentColor"
    />
  </svg>
);
